import styled from 'styled-components';


type IconLayoutProps = {
	marginLeft?: number;
	marginRight?: number;
}

const Content = styled.span`
	position: relative;
	display: inline-flex;
	align-items: center;
`;

const IconLayout = styled.span<IconLayoutProps>`
	display: inline-flex;

	${p => p.marginLeft && `
		margin-left: ${p.marginLeft}px;
	`}

	${p => p.marginRight && `
		margin-right: ${p.marginRight}px;
	`}
`;

export {
	Content,
	IconLayout,
}